import React from 'react';
import ReactDOM from 'react-dom/client';
// import App from './App'
import { ChakraProvider } from '@chakra-ui/react';
import "./App.css";
import { RouterProvider, createBrowserRouter, Outlet} from 'react-router-dom';
import Navbar from './components/Navbar';
import Homepage from './pages/Homepage';
import NotFound from './components/NotFound';
import AfspraakOverzicht from "./pages/AfspraakOverzicht";
import { AuthProvider } from './context/Auth.context';
import Login from './pages/Login';
import PrivateRoute from './components/PrivateRoute';
import Logout from './pages/Logout';
import Register from './pages/Register';
import Appointment from './components/Appointment'
import ManageAppointments from './components/Admins/ManageAppointments';
import { LogoutProvider } from "./context/LogoutContext";
import { LoginProvider } from "./context/LoginContext";
import { Box } from '@chakra-ui/react';
import Closure from './components/Admins/Closure';
import UpcomingAppointments from './components/UpcomingAppointments';
import AdminRoute from './components/Admins/AdminRoute';
import Footer from './components/Footer';


function Layout() {
    return (
      <Box display="flex" flexDirection="column" minHeight="100vh">
        <Navbar />
        <Box flex="1" minHeight="calc(100vh + 1px)">
            <Outlet />
        </Box>
        <Footer />
      </Box>
    );
  }
  


const router = createBrowserRouter([
    {
        element: <Layout />,
        children: [
            {
                path: '/',
                element: <Homepage/>,
            },
            {
                path: '/login',
                element: <Login />,
            },
            {
                path: '/logout',
                element: <Logout />,
            },
            {
                path: '/register',
                element: <Register />,
            },
            {
                path: '/appointment',
                element: <Appointment/>
            },
            {
                path: '/appointment/admin',
                element: (
                  <AdminRoute>
                    <Appointment isAdminBooking={true} />
                  </AdminRoute>
                )
              },
            {
                path: '/manage-appointments',
                element: (
                  <AdminRoute>
                    <ManageAppointments />
                  </AdminRoute>
                )
            },
            {
                path: '/closure',
                element: (
                  <AdminRoute>
                    <Closure />
                  </AdminRoute>
                )
            },
            {
                path: '/upcoming-appointments',
                element: <UpcomingAppointments/>
            },
            {
                path: '/afspraak-overzicht',
                element: <AfspraakOverzicht/>
            }
        ],
    },
    {
        path: '*',
        element: <NotFound />,
    },
    
]);


ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <LoginProvider>
        <LogoutProvider>
        <ChakraProvider>
            <AuthProvider>
                    <RouterProvider router ={router} />
            </AuthProvider>
        </ChakraProvider>
        </LogoutProvider>
        </LoginProvider>
    </React.StrictMode>,
);
